import Tabs from './Tabs';

export type { TabsProps } from './Tabs';
export default Tabs;
